<mat-form-field>
  <input (ngModelChange)="changeValue($event)" [ngModel]="rule.value" matInput type="number">
</mat-form-field>
